import { type SVGProps } from 'react'

export const DarkModeIcon: { __brand: 'color' | 'nocolor' } = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6957 7.45832C12.8676 7.27227 12.9455 7.01816 12.9075 6.76775C12.8695 6.51734 12.7196 6.29781 12.5003 6.17117C11.7402 5.73233 10.878 5.5013 10.0003 5.5013C9.12259 5.5013 8.26037 5.73233 7.50028 6.17117C6.74018 6.61001 6.10899 7.2412 5.67015 8.0013C5.23131 8.76139 5.00027 9.62361 5.00028 10.5013C5.00027 11.379 5.23131 12.2412 5.67015 13.0013C6.10899 13.7614 6.74018 14.3926 7.50028 14.8314C8.26037 15.2703 9.12259 15.5013 10.0003 15.5013C10.878 15.5013 11.7402 15.2703 12.5003 14.8314C12.7196 14.7048 12.8695 14.4853 12.9075 14.2348C12.9455 13.9844 12.8676 13.7303 12.6957 13.5443L12.4965 13.3286C11.0218 11.7322 11.0218 9.27042 12.4965 7.674L12.6957 7.45832ZM10.0003 7.16797C10.242 7.16797 10.4819 7.19424 10.716 7.24571C9.39307 9.20897 9.39307 11.7936 10.716 13.7569C10.4819 13.8084 10.242 13.8346 10.0003 13.8346C9.41515 13.8346 8.84034 13.6806 8.33361 13.3881C7.82688 13.0955 7.40608 12.6747 7.11352 12.168C6.82096 11.6612 6.66694 11.0864 6.66694 10.5013C6.66694 9.91618 6.82096 9.34136 7.11352 8.83463C7.40609 8.3279 7.82688 7.90711 8.33361 7.61455C8.84034 7.32199 9.41515 7.16797 10.0003 7.16797Z"
        fill="var(--color-icon-base-default, #707070)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3337 10.5013C18.3337 5.89893 14.6027 2.16797 10.0003 2.16797C5.39795 2.16797 1.66699 5.89893 1.66699 10.5013C1.66699 15.1037 5.39795 18.8346 10.0003 18.8346C14.6027 18.8346 18.3337 15.1037 18.3337 10.5013ZM10.0003 3.83464C13.6822 3.83464 16.667 6.8194 16.667 10.5013C16.667 14.1832 13.6822 17.168 10.0003 17.168C6.31843 17.168 3.33366 14.1832 3.33366 10.5013C3.33366 6.8194 6.31843 3.83464 10.0003 3.83464Z"
        fill="var(--color-icon-base-default, #707070)"
      />
    </svg>
  )
}

DarkModeIcon.__brand = 'nocolor'
